<template>
  <div :class="$style.container">
    <CalloutsListItem
      v-for="message in callouts" :key="message.messageId"
      :callout="message"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CalloutsListItem from './CalloutsListItem'

export default {
  name: 'callouts-list',
  components: {
    CalloutsListItem
  },
  created () {
    this.fetch()
  },
  computed: {
    ...mapGetters({
      callouts: 'entities/callouts/list'
    })
  },
  methods: {
    ...mapActions({
      fetch: 'entities/callouts/fetch'
    })
  }
}
</script>

<style module lang="scss">
.container {
  flex-grow: 1;
  padding: 20px;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
